import React from 'react'
import SocialLogin from 'react-social-login'
 
const Button = ({ children, triggerLogin, ...props }) => (
  <button type="button" style={ {border: 'none',
    background: 'transparent'}}  onClick={triggerLogin} {...props}>
    { children }
  </button>
)
 
export default SocialLogin(Button)



// WEBPACK FOOTER //
// ./src/Component/SocialButton/SocialButton.js